import { useContext, useMemo } from "react";
import CurrentUserContext from "../contexts/CurrentUserContext";

const RESTRICTED_ACCESS_TYPES = new Set(["READ_ONLY", "SUPPORT"]);

export const isRestrictedAccessType = (accessType) =>
    RESTRICTED_ACCESS_TYPES.has(accessType);

export const useIsWriteRestrictedUser = () => {
    const { currentUser } = useContext(CurrentUserContext);

    return useMemo(
        () => isRestrictedAccessType(currentUser?.userAccessType),
        [currentUser?.userAccessType]
    )
};